import { Modal } from 'antd';
import ReactECharts from 'echarts-for-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useOrganizationConfigs } from '../../../api/Onboarding';
import { useCodeFrame } from '../../../api/Questions';
import useAuth from '../../../auth/useAuth';
import { ChartValueType } from '../../../constants';
import { getThemesBarChart } from '../../../echarts/ChartHelper';

function ThemeChartModal({ visible, closeModal, questionId, surveyId }) {
  const { user } = useAuth();

  const { data: configs } = useOrganizationConfigs(
    { organizationId: user.organization_id },
    { enabled: !!user.organization_id },
  );

  const {
    data: themeChart,
    isFetching: themeChartFetching,
    refetch,
  } = useCodeFrame(
    { questionId, surveyId },
    {
      enabled: visible && !!configs,
      select: (data) =>
        getThemesBarChart({
          themes: data.data.themes_data.themes,
          questionId,
          surveyId,
          chartValueType: ChartValueType.PERCENTAGE,
          clickable: false,
          organizationConfigs: configs,
        }),
    },
  );

  useEffect(() => {
    if (visible) {
      refetch();
    }
  }, [visible, refetch]);

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      footer={null}
      loading={themeChartFetching}
      width={780}
    >
      {themeChart && (
        <ReactECharts
          option={themeChart.option}
          style={{ height: themeChart.height, width: '100%' }}
          opts={{ renderer: 'svg' }}
        />
      )}
    </Modal>
  );
}

ThemeChartModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  questionId: PropTypes.number.isRequired,
  surveyId: PropTypes.number.isRequired,
};

export default ThemeChartModal;
